import useSWR from "swr";
import { changeRequestsService } from "../../api_client";
import {
  ChangeRequestDtoStatusEnum,
  ChangeRequestDtoTypeEnum,
  type ChangeRequestDto,
} from "../../../api";

const OPEN_STATUSES: ChangeRequestDtoStatusEnum[] = [
  ChangeRequestDtoStatusEnum.Pending,
  ChangeRequestDtoStatusEnum.ChangesRequested,
];

/**
 * Returns the seller's open PRODUCT_UPDATE change requests as a Set of
 * targetProductId values so callers can render a "Pending review" chip per
 * product card.
 */
export function useMyPendingProductChangeRequests() {
  return useSWR<{ pending: ChangeRequestDto[]; ids: Set<number> }>(
    "my-pending-product-change-requests",
    async () => {
      const response = await changeRequestsService.findMine({
        type: ChangeRequestDtoTypeEnum.ProductUpdate,
        pageSize: 100,
      } as never);
      const rows = response.data.data ?? [];
      const open = rows.filter((r) =>
        OPEN_STATUSES.includes(r.status as ChangeRequestDtoStatusEnum),
      );
      const ids = new Set<number>();
      for (const r of open) {
        if (typeof r.targetProductId === "number") ids.add(r.targetProductId);
      }
      return { pending: open, ids };
    },
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );
}
